import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { EntityAvatar } from "@/components/EntityAvatar";
import { Paperclip } from "lucide-react";
import { DocumentManager } from "@/components/DocumentManager";

// Salt-okunur detay görünümü: entity bilgilerini bölümler halinde gösterir + opsiyonel evrak yönetimi.
export function EntityDetailDialog({
  open, onClose, title, subtitle, badge, avatarSrc, avatarName,
  sections = [], docs, docConfig, docHeading = "Evraklar / Özlük Dosyası",
  footer, testid = "entity-detail",
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid={testid} className="max-h-[88vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <div className="flex items-center gap-3">
            {(avatarSrc !== undefined || avatarName) && <EntityAvatar src={avatarSrc} name={avatarName || title} size={48} />}
            <div className="min-w-0 flex-1">
              <DialogTitle className="font-heading">{title}</DialogTitle>
              {subtitle && <DialogDescription className="mt-0.5">{subtitle}</DialogDescription>}
            </div>
            {badge}
          </div>
        </DialogHeader>
        <div className="space-y-4">
          {sections.map((sec, si) => (
            <div key={si} data-testid={`${testid}-section-${si}`} className="rounded-lg border border-slate-200 bg-white p-3">
              <p className="mb-2 text-[11px] font-bold uppercase tracking-wide text-slate-400">{sec.heading}</p>
              <div className="grid grid-cols-1 gap-x-4 gap-y-0.5 sm:grid-cols-2">
                {sec.rows.filter(Boolean).map((r, ri) => (
                  <div key={ri} className={`flex items-center justify-between gap-3 border-b border-slate-50 py-1.5 last:border-0 ${r.full ? "sm:col-span-2" : ""}`}>
                    <span className="shrink-0 text-xs text-slate-500">{r.label}</span>
                    <span data-testid={r.testid} className={`min-w-0 break-words text-right text-sm font-medium ${r.accent || "text-slate-800"}`}>
                      {r.value === "" || r.value == null ? "—" : r.value}
                    </span>
                  </div>
                ))}
              </div>
              {sec.extra}
            </div>
          ))}
          {docConfig && (
            <div className="rounded-lg border border-slate-200 bg-white p-3">
              <p className="mb-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-400"><Paperclip className="h-3.5 w-3.5" /> {docHeading}</p>
              <DocumentManager docs={docs} onAdd={docConfig.onAdd} onDelete={docConfig.onDelete} canWrite={docConfig.canWrite} zipPath={docConfig.zipPath} testid={docConfig.testid || `${testid}-docs`} />
            </div>
          )}
          {footer}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default EntityDetailDialog;
